module.exports = __webpack_public_path__ + "img/frame (143).d7a35195.jpg";